/*
 * ===========================================================================
 * [StrongGate Limited] [http://www.stronggate.com]
 * Copyright (c) 2022-2026. All rights Reserved.
 * Unauthorized access, use, dissemination, distribution, reproduction of this
 * file, or a portion of, in any form is prohibited and unlawful. If you receive
 * this file, and you are not an authorized company employee, or you believe you
 * have received this file in error, please notify the sender (or originator)
 * and promptly delete this file.
 *
 * Project:
 * File: ApiUrlBuilder.ts
 * Created by: chan.ying
 * Create Date: 2026-06-25 08:48
 * Version Number: 1.0
 * Version Description:
 *
 * =============================================================================
 */

import AppConfig from "@/commons/AppConfig";

export default class ApiUrlBuilder {

    // ------------------------------------------------------------------------------------
    // singleton
    // ------------------------------------------------------------------------------------
    private static _instanceTeam: ApiUrlBuilder;

    // ------------------------------------------------------------------------------------

    public static get InstanceTeam() {
        return this._instanceTeam || (this._instanceTeam = new this([AppConfig.Instance.apiServiceTeam]))
    }

    /*public static get None() {
        return this._instanceTeam || (this._instanceTeam = new this([]))
    }*/

    private readonly apiUrl: string[];
    private _idx: number;

    private constructor(gws: string[]) {
        this.apiUrl = gws
        this._idx = 0
    }

    private internalResolve(): string {
        if (this.apiUrl == null || this.apiUrl.length == 0) {
            return ''
        }
        if (this.apiUrl.length == 1) {
            return this.apiUrl[0]
        }
        let r = this.apiUrl[this._idx]
        this._idx = this._idx + 1 >= this.apiUrl.length ? 0 : this._idx + 1
        return r
    }

    public resolve(uri: string): string {
        return this.internalResolve() + uri;
    }

    /**
     * Encode a single URL path segment so user-influenced values cannot
     * rewrite the request path (`/`, `?`, `#`, `..`, ...).
     */
    public static seg(value: string | number | null | undefined): string {
        return encodeURIComponent(String(value ?? ""));
    }

} // end class - GatewayResolver